import Immutable from 'immutable';

import StudentGeneralInfo from 'domain/StudentGeneralInfo';
import SessionAttendance from './';

const reviver = ([key, seq]) => {
  if (! seq) return [key, seq];
  switch (key) {
    case 'studentGeneralInfo':
      return [key, StudentGeneralInfo.create(seq)];
    default:
      return [key, Immutable.fromJS(seq)];
  }
};

export const create = (data) =>
  new SessionAttendance(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/SessionsAttendance/model/create.js